import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=8a0df558&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Orders.vue?vue&type=style&index=1&id=8a0df558&prod&lang=css&"
import style2 from "./Orders.vue?vue&type=style&index=2&id=8a0df558&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0df558",
  null
  
)

export default component.exports